import { Popover } from '@mui/material';
import type { AxiosResponse } from 'axios';
import axios from 'axios';
import React, { useEffect } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { useSnackbar } from 'notistack';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import StradaSpinner from 'shared-components/components/StradaSpinner';
import type { IBuildingResponse } from 'admin/buildingSection/budget-calendar/types';
import { useSelector } from 'react-redux';
import type { RootState } from 'mainStore';

interface IBuildingOption {
  name: string;
  value: number;
}

export default function BuildingsBar(): JSX.Element {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const [selectedBuilding, setSelectedBuiding] = React.useState<IBuildingOption | null>(null);
  const sideSheetData = useSelector((state: RootState) => state.workspaces.sideSheetData.sideSheetData);
  const currentWorkspace = useSelector((state: RootState) => state.workspaces.currentWorkspace.currentWorkspace);

  useEffect(() => {
    setAnchorEl(null);
  }, [selectedBuilding]);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const { data: buildings = [] } = useQuery(
    ['building-in-sidesheet'],
    async () => axios({
      url: `/api/filter/property/?workspace=${currentWorkspace.id}`,
      method: 'get',
    }),
    {
      select: (res: AxiosResponse<IBuildingResponse>) => res.data.detail.map((building) => ({ name: building.address, value: building.id })),
    },
  );

  useEffect(() => {
    if (sideSheetData !== null) {
      const currentBuilding = buildings.filter((building) => sideSheetData.building.id === building.value);
      if (currentBuilding.length !== 0) {
        setSelectedBuiding(currentBuilding[0]);
      } else {
        setSelectedBuiding(null);
      }
    } else {
      setSelectedBuiding(null);
    }
  }, [sideSheetData, buildings]);

  const { mutate: updateBuilding, isLoading: updatingBuilding } = useMutation(async (buildingId: number) => axios({
    url: `/api/budget-calendar/event/${sideSheetData?.id}/`,
    method: 'PATCH',
    data: {
      property: buildingId,
    },
  }), {
    onSuccess: async (): Promise<void> => {
      await queryClient.invalidateQueries('others-events').then();
      await queryClient.invalidateQueries('user-created-events').then();
      await queryClient.invalidateQueries('sidesheet/get-events').then();
      await queryClient.invalidateQueries('user-assigned-events').then();
      await queryClient.invalidateQueries('prioritized-events').then();
      await queryClient.invalidateQueries('allevents/get-events').then();

      enqueueSnackbar('Building updated successfully');
    },
    // onError: async (): Promise<void> => {
    //   await queryClient.invalidateQueries('others-events').then();

    //   await queryClient.invalidateQueries('sidesheet/get-events').then();
    //   await queryClient.invalidateQueries('user-assigned-events').then();
    //   await queryClient.invalidateQueries('prioritized-events').then();
    //   await queryClient.invalidateQueries('allevents/get-events').then();
    //   await queryClient.invalidateQueries('user-created-events').then();
    // },
  });
  return (
    <div className='assignee-sheet-bar'>
      <h6 className='side-sheet-side-label'> Building </h6>
      <div className='assignee-sheet-popover'>
        <div className='popover-btn' onClick={handleClick} aria-hidden='true' style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {updatingBuilding ? <StradaSpinner open={updatingBuilding} message='Updating' /> : (
            <>
              <p>
                {' '}
                {selectedBuilding ? selectedBuilding.name : <HorizontalRuleIcon fontSize='small' />}
                {' '}
              </p>
              <ArrowDropDownIcon fontSize='small' htmlColor='' />
            </>
          )}
        </div>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <div className='assignee-popover'>
            {/* <div className={selectedBuilding === null ? 'popover-option active' : 'popover-option'} key='firts-option' onClick={(): void => { setSelectedBuiding(null); }} aria-hidden='true'>
              <h5>No Assignee</h5>
            </div> */}
            {buildings.map((building) => (
              <div className={selectedBuilding !== null && selectedBuilding.value === building.value ? 'popover-option active' : 'popover-option'} key={building.name} onClick={(): void => { updateBuilding(building.value); }} aria-hidden='true'>
                <h5>
                  {' '}
                  {building.name}
                  {' '}
                </h5>
              </div>
            ))}

          </div>
        </Popover>

      </div>
    </div>
  );
}
